import { render } from "./DeanCourseOutcomes.vue?vue&type=template&id=35da2dde"
import script from "./DeanCourseOutcomes.vue?vue&type=script&lang=js"
export * from "./DeanCourseOutcomes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__